var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIntegrately = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45153 12.3525C6.42048 12.0287 6.6749 11.7487 6.99992 11.7487H16.9896C17.3218 11.7487 17.5804 12.0373 17.5442 12.3677L17.3441 14.1946C17.0446 16.9293 14.7358 19 11.9864 19C9.20886 19 6.88622 16.8883 6.62112 14.1219L6.45153 12.3525Z",
    fill: "#FD641F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75459 10.398C10.5361 10.4302 10.7931 10.3337 10.8252 9.84053C10.8573 8.96138 10.8573 8.1144 10.8252 7.22457C10.8252 6.90289 10.5683 6.66703 10.2685 6.66703C10.0758 6.66703 9.91522 6.66703 9.71178 6.66703C9.35852 6.66703 9.12301 6.92438 9.09087 7.28891C9.09087 7.7177 9.09087 8.10372 9.09087 8.53252C9.09087 8.96138 9.09087 9.3795 9.09087 9.80836C9.13368 10.1621 9.36926 10.3659 9.75459 10.398Z",
    fill: "#FD641F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8554 10.4053C14.6159 10.4053 14.9092 10.2774 14.9092 9.81925C14.9092 8.94559 14.9092 8.10376 14.9092 7.21942C14.9092 6.89972 14.6486 6.69736 14.3117 6.66532C14.1488 6.66532 13.9532 6.66532 13.7793 6.66532C13.3774 6.66532 13.1492 6.88911 13.1492 7.28336C13.1492 7.67761 13.1492 8.09315 13.1492 8.4874C13.1492 8.91356 13.1492 9.32916 13.1492 9.78729C13.1927 10.1709 13.4208 10.4053 13.8554 10.4053Z",
    fill: "#FD641F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12Z",
    fill: "#FD641F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIntegrately);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Integrately.6959cde4e2d540bde06949b311c97d29.svg";